export const PROCESS_TASK_MODALS = {
  create: 'create',
  delete: 'delete',
  edit: 'edit'
};

